import flag from '../assets/img/flag.gif';
import Search from '../components/Search';
import About from '../components/About';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import SubscribeForm from '../components/forms/SubscribeForm';
import FAQ from '../components/FAQ';
import Layout from '../components/layout/Layout';

const HomePage = () => {
    return (
        <Layout>
            <Header marquee/>

            <div className="flex flex-col gap-10 my-10">
                <section className="pt-6 pb-4 px-5 rounded-xl">
                    <div className="flex justify-center gap-3">
                        <img className="h-12 rounded-full" src={flag} alt="flag"/>

                    </div>
                    <div className="flex flex-col gap-4 text-center py-3 mb-1.5">
                        <h2 className="text-neutral-900 tracking-light text-3xl font-bold leading-8 px-4">Find the
                            Best <br/> Candidates Around You</h2>
                        <p className="text-neutral-700 px-4 leading-5">
                            To get started, enter the address where <br/> you are registered to vote
                        </p>
                    </div>
                    <Search/>
                </section>

                <div className="mb-6">
                    <About/>
                    <FAQ/>
                </div>

                <SubscribeForm/>


            </div>

            <Footer/>
        </Layout>
    );
};

export default HomePage;
